import React from 'react'
import { Button, Container, Grid } from 'gu-ui-kit'
import styles from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/EditorTypeSwitcher/edit-mode-switcher.module.scss'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import Dot from 'components/Dot'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const EditModeSwitcher = ({
  resource,
  availableEditorTypes,
  currentType,
  setType,
}) => {
  const { t } = useTranslation()
  const { md } = useBreakpoint()
  const editorState = useSelector((state) => state['services/budget-editor'])

  return (
    <Grid fluid={false} className={'margin-bottom-24'}>
      <Container className={styles['buttons-group']}>
        {availableEditorTypes.map((type) => {
          const rows = editorState[type].rows

          return (
            <Button
              noWrap
              className={styles['buttons-group__button']}
              onClick={() => setType(type)}
              variant={currentType === type ? 'primary' : 'ghost'}
              size={!md ? 's' : 'm'}
              key={'switcher-to-' + type}
              noHover
              color={
                currentType === type ? 'Label-Onsurface' : 'Label-Secondary'
              }
              bgColorHover={'none'}
              endIcon={
                <Dot
                  touched={rows.find((r) => r.rowState?.touched)}
                  error={rows.find((r) => r.rowState?.error)}
                />
              }
            >
              {t('campaigns_editor::budget_editor.type.' + type, {
                context: resource,
              })}
            </Button>
          )
        })}
      </Container>
    </Grid>
  )
}

export default EditModeSwitcher

EditModeSwitcher.propTypes = {
  resource: PropTypes.string.isRequired,
  availableEditorTypes: PropTypes.array.isRequired,
  currentType: PropTypes.string.isRequired,
  setType: PropTypes.func.isRequired,
}
